module.exports = __webpack_public_path__ + "img/star_starcadiatok.a61217f.png";